import { BaserowClient } from "./baserow-client";

/**
 * Operations for managing Baserow applications.
 */
export class ApplicationOperations {
  constructor(private client: BaserowClient) {}
  
  // Application methods will be implemented here
} 